import { PlanType, StatusListing } from '@labrav/react-components'
import { isEmpty } from 'lodash'
import {
  MicrosoftOfferStages,
  PrivateOffer,
  StatusOfferResObj,
} from '../../../modules/privateOffer/types'
import { getStatusOfferData } from '../../../utils/offerEditUtil'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { CloudMarketplace } from '../../../types'
import { useSelector } from 'react-redux'
import { getMicrosoftPOStagesData } from '../../../utils/privateOfferOrResaleHelperFunctions'

type StatusStagesRootState = {
  userProfile?: {
    userProfile?: {
      timeZone?: string
      defaultTimeZone?: string
    }
  }
}

export const StatusStages = ({
  privateOffer,
  cloudMarketplace,
  planType,
}: {
  privateOffer: PrivateOffer
  cloudMarketplace?: CloudMarketplace
  planType?: PlanType
}) => {
  const timeZone = useSelector<StatusStagesRootState, string>(
    state =>
      state.userProfile?.userProfile?.timeZone ||
      state.userProfile?.userProfile?.defaultTimeZone ||
      'UTC'
  )
  const statusMap = getStatusMapping({
    cloud: cloudMarketplace,
    privateOffer,
    planType,
  })
  return (
    <>
      {!isEmpty(statusMap) && (statusMap || [])?.length > 0 && (
        <StatusListing
          statuses={statusMap || []}
          title={'Offer stage'}
          titleIcon={faListCheck}
          timeZone={timeZone}
          {...(cloudMarketplace === 'AZURE'
            ? { useBuiltinStyles: false, isNextCompletedSupport: true }
            : {})}
        />
      )}
    </>
  )
}

const getAuditJson = ({
  cloud,
  privateOffer,
}: {
  cloud?: CloudMarketplace
  privateOffer: PrivateOffer
}) => {
  switch (cloud) {
    case 'AWS': {
      return {
        'Created at Labra': privateOffer.auditJson?.offerCreatedAt ?? '',
        Sent: privateOffer.auditJson?.offerSentAt ?? '',
        Viewed: privateOffer.auditJson?.offerViewedAt ?? '',
        Accepted: privateOffer.auditJson?.offerAcceptedAt ?? '',
      }
    }
    case 'AZURE': {
      return {
        'Created at Labra':
          privateOffer?.statusLogs?.offerCreationInProgress ?? '',
        'Sent to buyer': privateOffer?.statusLogs?.offerEmailSent ?? '',
        'Viewed by buyer': privateOffer?.statusLogs?.offerViewed ?? '',
        'Pending purchase':
          privateOffer?.statusLogs?.offerTermsAcceptedBuyer ?? '',
        'Pending account configuration':
          privateOffer?.statusLogs?.offerPurchaseComplete ?? '',
        Accepted: privateOffer?.statusLogs?.offerAccepted ?? '',
        Expired: privateOffer?.statusLogs?.offerExpired ?? '',
        'Deactivation in progress':
          privateOffer?.statusLogs?.offerRestrictionInProgress ?? '',
        Deactivated: privateOffer?.statusLogs?.offerRestricted ?? '',
      }
    }
    case 'GCP': {
      return {}
    }
    case 'REDHAT': {
      return {}
    }
  }
}

const getStatusMapping = ({
  cloud,
  privateOffer,
  planType,
}: {
  cloud?: CloudMarketplace
  privateOffer: PrivateOffer
  planType?: PlanType
}) => {
  const auditJson = getAuditJson({ cloud: cloud, privateOffer })
  const hidePendingAccountConfiguration = planType === PlanType.CONTAINER
  switch (cloud) {
    case 'AWS': {
      const statuses = getStatusOfferData(
        auditJson as StatusOfferResObj,
        privateOffer?.offerStatus
      )?.sort((a, b) => (a?.sortOrder || 0) - (b?.sortOrder || 0))
      return statuses?.filter(i => i.display)
    }
    case 'AZURE': {
      const stageDataArray = getMicrosoftPOStagesData(
        auditJson as MicrosoftOfferStages,
        privateOffer.offerStatus,
        privateOffer?.statusLogs?.offerCreationFailed,
        { hidePendingAccountConfiguration }
      )
      const filteredStageDataArray = stageDataArray
        ?.filter(obj => obj.display === true)
        ?.sort((a, b) => (a?.sortOrder || 0) - (b?.sortOrder || 0))
      return filteredStageDataArray
    }
  }
}
